module.exports = __webpack_public_path__ + "img/edit-case-information.3ec7d81b.svg";